import * as yup from 'yup';

const schema = yup.object().shape({
  name: yup.string().label('Name').min(2, 'Name should be at least 2 symbols').required(),
  length: yup.number().label('Length').required(),
  width: yup.number().label('Width').required(),
  height: yup.number().label('Height').required(),
  weight: yup.number().label('Weight').required(),
});

export default schema;
